import { createContext, useState, useMemo, ReactNode, FC } from "react"

export const ModalContext = createContext({
   
  isModalActive: false,
  setIsModalActive: (_value: boolean) => {},
   
})

export const ModalContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [isModalActive, setIsModalActive] = useState(false)
  const fields = useMemo(() => ({ isModalActive, setIsModalActive }), [isModalActive, setIsModalActive])

  return <ModalContext.Provider value={fields}>{children}</ModalContext.Provider>
}
export default ModalContext
